import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
import { BookOpenIcon, ListChecksIcon, BrainIcon, LayersIcon, CalendarIcon, CreditCardIcon, ClipboardListIcon } from 'lucide-react';
export function WhatYouGetSection() {
  return <SectionWrapper data-id="element-284">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-12" variants={childVariants} data-id="element-285">
        What you get instantly
      </motion.h2>

      <motion.p className="font-heading text-lg text-teal-light mb-8" variants={childVariants} data-id="element-286">
        The 3AM Reset ebook (PDF) including:
      </motion.p>

      <motion.ul className="space-y-6 mb-14" variants={childVariants} data-id="element-287">
        <li className="flex items-start gap-4" data-id="element-288">
          <div className="mt-1 w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-289">
            <BookOpenIcon className="w-4 h-4 text-teal-light" data-id="element-290" />
          </div>
          <div data-id="element-291">
            <p className="font-body text-lg text-cream font-medium" data-id="element-292">
              Quick Start page for the moment you wake up
            </p>
            <p className="font-body text-base text-cream-muted mt-1" data-id="element-293">
              The 90-Second Rule
            </p>
          </div>
        </li>
        <li className="flex items-start gap-4" data-id="element-294">
          <div className="mt-1 w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-295">
            <LayersIcon className="w-4 h-4 text-teal-light" data-id="element-296" />
          </div>
          <div data-id="element-297">
            <p className="font-body text-lg text-cream font-medium" data-id="element-298">
              3 "Body Downshift" options
            </p>
            <p className="font-body text-base text-cream-muted mt-1" data-id="element-299">
              Pick one and lock it in
            </p>
          </div>
        </li>
        <li className="flex items-start gap-4" data-id="element-300">
          <div className="mt-1 w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-301">
            <BrainIcon className="w-4 h-4 text-teal-light" data-id="element-302" />
          </div>
          <div data-id="element-303">
            <p className="font-body text-lg text-cream font-medium" data-id="element-304">
              The Brain Off‑Ramp scripts
            </p>
            <p className="font-body text-base text-cream-muted mt-1" data-id="element-305">
              So you're not improvising at 3am
            </p>
          </div>
        </li>
        <li className="flex items-start gap-4" data-id="element-306">
          <div className="mt-1 w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-307">
            <ListChecksIcon className="w-4 h-4 text-teal-light" data-id="element-308" />
          </div>
          <div data-id="element-309">
            <p className="font-body text-lg text-cream font-medium" data-id="element-310">
              The Return-to-Sleep Ladder
            </p>
            <p className="font-body text-base text-cream-muted mt-1" data-id="element-311">
              A no-bargaining sequence
            </p>
          </div>
        </li>
        <li className="flex items-start gap-4" data-id="element-312">
          <div className="mt-1 w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-313">
            <CalendarIcon className="w-4 h-4 text-teal-light" data-id="element-314" />
          </div>
          <div data-id="element-315">
            <p className="font-body text-lg text-cream font-medium" data-id="element-316">
              A full 14-Night Reset Plan
            </p>
            <p className="font-body text-base text-cream-muted mt-1" data-id="element-317">
              Track progress without obsessing
            </p>
          </div>
        </li>
      </motion.ul>

      {/* Bonuses */}
    </SectionWrapper>;
}